import { QuizQuestionProps } from "@/pages/quiz/context/types";

const WelcomeScreen = ({
  question: { attributes },
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  return (
    <div className="custom-welcome-screen">
      <h1 className="quiz-title">{attributes.title}</h1>
      <div className="text-base sm:text-lg font-normal text-dark-purple-2 text-center">
        {attributes.subtitle}
      </div>
      <button
        className="renderer-core-button css-lgveel !mt-5"
        onClick={() => setQuestionAnswer(true)}
      >
        {attributes.nextBtnLabel}
      </button>
    </div>
  );
};

export { WelcomeScreen };
